export default {"src":"/_next/static/media/youtube.9877fbba.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};